export const LOADING = 'LOADING';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const DONE = 'DONE';
export const NOT_STARTED = 'NOT_STARTED';
export const DOC_COMPARE = 'DOC_COMPARE';
export const RE_ANALYSIS = 'RE_ANALYSIS';
export const CLEAR = 'CLEAR';

export const firstChange = 'NAVIGATE_TO_FIRST_CHANGE';
export const lastChange = 'NAVIGATE_TO_LAST_CHANGE';
export const nextChange = 'NAVIGATE_TO_NEXT_CHANGE';
export const prevChange = 'NAVIGATE_TO_PREVIOUS_CHANGE';
// export const nextChange='NAVIGATE_TO_LAST_CHANGE';

export const originalDocument = 'ORIGINAL_DOCUMENT';
export const modifiedDocument = 'MODIFIED_DOCUMENT';
export const singleDocument = 'SINGLE_DOCUMENT';
export const addition = '+';
export const substraction = '-';
export const MIN_ZOOM_LEVEL = 0.7;
export const MAX_ZOOM_LEVEL = 1.3;

export const SAVED = 'SAVED';
export const SHARED = 'SHARED';

export const canvasWidth = 594;
export const canvasHeight = 843;

export const DOC_CHAT = 'DOC_CHAT';

export const contradictionColors = [
  { backgroundColor: '#E0F7FA', textColor: '#006064' }, // Light Cyan + Dark Cyan
  { backgroundColor: '#F1F8E9', textColor: '#33691E' }, // Light Green + Dark Green
  { backgroundColor: '#FFF3E0', textColor: '#E65100' }, // Light Orange + Deep Orange
  { backgroundColor: '#FCE4EC', textColor: '#880E4F' }, // Light Pink + Dark Pink
  { backgroundColor: '#E8EAF6', textColor: '#1A237E' }, // Light Indigo + Deep Indigo
  { backgroundColor: '#F3E5F5', textColor: '#4A148C' }, // Light Purple + Deep Purple
];

export const DOCCHAT_MAX_FILES = 300;

export const DOCCOMPARE_MAX_FILES = 6;

export const WELCOME_MODAL_DOC_COMPARE = 'welcome_modal_docCompare';
export const WELCOME_MODAL_DOC_CHAT = 'welcome_modal_docChat';
export const WORKFLOW_INTRO_MODAL = 'workflow_intro_modal';

export const SENTRY_IGNORE_STATUS = [400, 401, 403, 404, 409, 422];

// DocChat tab management
export const DOCCHAT_ACTIVE_TAB_KEY = 'docchat-active-tab';
export const ACTIVE_TAB_MAPPING = {
  chat: 'chat',
  presets: 'presets',
};
